import React from 'react';
import { Box, Typography, Container, Grid, Link as MuiLink, IconButton, useTheme } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { Link } from 'react-router-dom';

export const Footer = () => {
    const theme = useTheme();
    const currentYear = new Date().getFullYear();

    const sections = [
        {
            title: "Platform",
            links: [{ name: "Home", to: "/" }, { name: "Community Rooms", to: "/community" }, { name: "Resources Explorer", to: "/resources" }],
        },
        {
            title: "Support",
            links: [{ name: "FAQ", to: "/faq" }, { name: "Contact Us", to: "/contact" }, { name: "Privacy Policy", to: "/privacy" }],
        },
        {
            title: "Account",
            links: [{ name: "Login", to: "/login" }, { name: "Sign Up", to: "/signup" }],
        },
    ];

    return (
        <Box 
            component="footer" 
            sx={{ 
                bgcolor: theme.palette.text.primary, // Dark footer for contrast
                color: theme.palette.background.paper, 
                py: 6,
                borderTop: `4px solid ${theme.palette.secondary.main}`
            }}
        >
            <Container maxWidth="xl">
                <Grid container spacing={4}>
                    
                    {/* Brand / Mission Statement */}
                    <Grid item xs={12} md={4}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                            <MenuBookIcon sx={{ mr: 1, color: theme.palette.secondary.main }} />
                            <Typography variant="h6" sx={{ fontWeight: 700 }}>
                                PRODUCT OF MY ENVIRONMENT
                            </Typography>
                        </Box>
                        <Typography variant="body2" sx={{ opacity: 0.8 }}>
                            Shifting the community mindset by connecting people with knowledge, support, and vital resources.
                        </Typography>
                    </Grid>

                    {/* Navigation Links */}
                    {sections.map((section) => (
                        <Grid item xs={6} sm={3} md={2} key={section.title}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1.5 }}>
                                {section.title}
                            </Typography>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                {section.links.map((link) => (
                                    <MuiLink 
                                        component={Link} 
                                        to={link.to} 
                                        key={link.name}
                                        color="inherit" 
                                        sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline', color: theme.palette.secondary.light } }}
                                    >
                                        {link.name}
                                    </MuiLink>
                                ))}
                            </Box>
                        </Grid>
                    ))}
                    
                    {/* Social Media */}
                    <Grid item xs={12} sm={6} md={2}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1.5 }}>
                            Connect
                        </Typography>
                        <Box>
                            <IconButton color="inherit" aria-label="facebook"><FacebookIcon /></IconButton>
                            <IconButton color="inherit" aria-label="twitter"><TwitterIcon /></IconButton>
                            <IconButton color="inherit" aria-label="instagram"><InstagramIcon /></IconButton>
                        </Box>
                    </Grid>
                </Grid>
                
                <Box sx={{ borderTop: '1px solid rgba(255, 255, 255, 0.1)', mt: 4, pt: 3, textAlign: 'center' }}>
                    <Typography variant="caption" sx={{ opacity: 0.6 }}>
                        &copy; {currentYear} Product of My Environment. All rights reserved.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};